@let hasErrorValue = hasError();
@let hintValue = hint();
@let valueValue = value();

<rt-box layout-vertical [class.single-line-field__box--invalid]="hasErrorValue">
  <rt-form-field>
    <rt-evaluation-field-label
      [title]="title()"
      [hint]="hintValue"
      [required]="required()"
      [filled]="!!valueValue"
    />

    <rt-input
      [formControl]="control()"
      [disableInvalidStyles]="true"
      [placeholder]="'app.evaluation_panel.your_answer' | translate"
      margin-top-small-x
    />
  </rt-form-field>
</rt-box>

@if (hasErrorValue) {
  <div class="single-line-field__error">
    {{ 'app.evaluation_panel.errors.basic_required' | translate }}
  </div>
}
